import { BaseLayout } from "@/components/layout/base-layout";
import { EmailConfirmationPage } from "@/components/pages/email-confirmation-page";
import { ErrorFallback } from "@/components/common/error-fallback";
import { InteractionsPage } from "@/components/pages/interactions-page";
import LanguageMetricsDashboard from "@/components/pages/metrics-dashboard-page";
import { LoginPage } from "@/components/pages/login-page";
import { PasswordRecoveryPage } from "@/components/pages/password-recovery-page";
import { PasswordResetPage } from "@/components/pages/password-reset-page";
import ProfilePage from "@/components/pages/user-profile";
import { RequireAuth } from "@/require-auth";
import { SidebarLayout } from "@/components/layout/sidebar-layout";
import { SignupPage } from "@/components/pages/signup-page";
import UserInfoForm from "@/components/pages/user-info-progresive-page";
import VoiceChatPage from "@/components/pages/voicechat-page";
import { createBrowserRouter } from "react-router-dom";

export const routers = createBrowserRouter([
  {
    element: <BaseLayout />,
    errorElement: <ErrorFallback />,
    children: [
      {
        path: "/",
        element: <LoginPage />,
      },
      {
        path: "/login",
        element: <LoginPage />,
      },
      {
        path: "/signup",
        element: <SignupPage />,
      },
      {
        path: "/password-recovery",
        element: <PasswordRecoveryPage />,
      },
      {
        path: "/password-reset/:token",
        element: <PasswordResetPage />,
      },
      {
        path: "/email-confirmation",
        element: <EmailConfirmationPage />,
      },
      {
        path: "*",
        element: <p>404</p>,
      },
    ],
  },
  {
    element: <RequireAuth />, // For protected routes
    errorElement: <ErrorFallback />,
    path: "/app",
    children: [
      {
        path: "/app/user-info",
        element: <UserInfoForm />,
      },
      {
        element: <SidebarLayout hasLanguageSelector={false} />, // Layout with sidebar
        children: [
          {
            path: "/app/profile",
            element: <ProfilePage />,
          },
          {
            path: "*",
            element: <p>404</p>,
          },
        ],
      },
      {
        element: <SidebarLayout hasLanguageSelector={true} />, // Layout with sidebar
        children: [
          {
            path: "/app/voicechat",
            element: <VoiceChatPage />,
          },
          {
            path: "/app/metrics",
            element: <LanguageMetricsDashboard />,
          },
          {
            path: "/app/interactions",
            element: <InteractionsPage />,
          },
        ],
      },
    ],
  },
]);
